var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col md:flex-row mb-6" }, [
    _c("div", { staticClass: "md:w-80 mb-1 md:mb-0" }, [
      _c("h3", { staticClass: "font-medium text-sm md:text-base" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
    ]),
    _c("div", { staticClass: "flex flex-col" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }